/**
 * Shared trust-boundary guard for user-typed text fields.
 *
 * React escapes HTML on render, so this is about what we *send* to the backend:
 * reject values that carry HTML/script markup or classic SQL/NoSQL injection
 * payloads before they ever leave the form. The backend must still validate and
 * use parameterised queries — this is defence in depth, not the only line.
 *
 * ponytail: pattern-based blocklist (rejects a lone `'`, `;`, `<`, `$`…). Firm
 * on purpose; if a legit value like the surname O'Brien must pass, relax the
 * SQL-quote rule here rather than in each form.
 */

// <tag>, </tag>, <!-- -->, entities, and event/script vectors.
const HTML_RE = /<[^>]*>|<\/?[a-z]|&#?\w+;|javascript:|on\w+\s*=/i;

// Quotes, statement terminators, comments, and classic SQL keywords.
const SQL_RE =
  /['"`;]|--|\/\*|\*\/|\b(select|insert|update|delete|drop|union|create|alter|truncate|exec|declare|or\s+1\s*=\s*1)\b/i;

// Mongo/NoSQL operators and JSON-ish object injection: $where, {"$gt":…}, etc.
const NOSQL_RE = /\$\w+|[{}]/;

/**
 * @returns {string|undefined} an error message if the value looks dangerous,
 *   otherwise undefined.
 */
export function checkInjection(value) {
  if (typeof value !== 'string' || value === '') return undefined;
  if (HTML_RE.test(value)) return 'No se permite HTML ni etiquetas.';
  if (SQL_RE.test(value) || NOSQL_RE.test(value))
    return 'Contiene caracteres no permitidos.';
  return undefined;
}
